import { Schedule as ScheduleIcon } from "@mui/icons-material";
import { Button } from "@mui/material";

// User-facing strings
const STRINGS = {
  ADD_EVENT_TIMES: "Create",
} as const;

interface AddEventTimesButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const AddEventTimesButton = ({ onClick, disabled }: AddEventTimesButtonProps) => {
  return (
    <Button
      variant="contained"
      startIcon={<ScheduleIcon />}
      onClick={onClick}
      disabled={disabled}
      fullWidth
      sx={{
        "&:hover": {
          background: (theme) =>
            `linear-gradient(135deg, ${theme.palette.success.dark} 0%, ${theme.palette.success.dark} 100%)`,
        },
        background: (theme) =>
          `linear-gradient(135deg, ${theme.palette.success.main} 0%, ${theme.palette.success.dark} 100%)`,
        borderRadius: "12px",
        color: "white",
        fontWeight: "bold",
        textTransform: "none",
      }}
    >
      {STRINGS.ADD_EVENT_TIMES}
    </Button>
  );
};
